import Vue from 'vue'
import axios from 'axios'

const state = {
  loading: true,
  pages: 0,
  pagination: {
    page: 1,
    limit: 10
  },
  projects: [],
  search: ''
}

const getters = {
  loading: state => state.loading,
  pages: state => state.pages,
  pagination: state => state.pagination,
  projects: state => state.projects,
  search: state => state.search
}

const actions = {
  async fetchProjects({ commit, state }) {
    commit('setLoading', true)

    const { pagination, search } = state
    const { page, limit } = pagination

    try {
      const response = await axios.get(
        `${Vue.prototype.$apiUrl}Projeto.svc/projeto?page=${page ||
          1}&limit=${limit}&filter=${search || ''}`, {withCredentials: true}
      )

      const { data } = response
      commit('setProjects', data.items)
      commit('setPages', Math.ceil(data.totalItemCount / limit))
      commit('setLoading', false)
    } catch (e) {
      commit('setLoading', false)
    }
  },
  filter({ commit }, event) {
    event.preventDefault()

    const [input] = event.target
    commit('setSearch', input.value)
    commit('setPagination', { ...state.pagination, page: 1 })
  },
  reset({ commit, dispatch }) {
    commit('setSearch', '')
    dispatch('fetchProjects')
  }
}

const mutations = {
  setLoading: (state, loading) => (state.loading = loading),
  setPages: (state, pages) => (state.pages = pages),
  setPagination: (state, pagination) => (state.pagination = pagination),
  setProjects: (state, projects) => (state.projects = projects),
  setSearch: (state, search) => (state.search = search)
}

export default {
  state,
  getters,
  actions,
  mutations
}
